import { createConfirmation } from "react-confirm";
import AddSalableTypeDialog from "./AddSalableTypeDialog";

export const showAddSalableTypeDialog = createConfirmation(AddSalableTypeDialog);
